import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Box, Paper, Stack, Typography, TextField, Button, Alert, CircularProgress } from "@mui/material";
import { useAuth } from "../auth/AuthContext";

export default function LoginPage() {
  const { authenticated, loading, login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/admint/";

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!loading && authenticated) {
      navigate(from, { replace: true });
    }
  }, [loading, authenticated, from, navigate]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (!username.trim() || !password) {
      setError("Enter both fields.");
      return;
    }
    setBusy(true);
    const res = await login(username.trim(), password);
    setBusy(false);
    if (res.ok) {
      navigate(from, { replace: true });
    } else {
      setError(res.error || "Invalid credentials.");
    }
  };

  if (loading) {
    return (
      <Box sx={{ minHeight: "100vh", display: "grid", placeItems: "center" }}>
        <CircularProgress size={20} />
      </Box>
    );
  }

  return (
    <Box sx={{ minHeight: "100vh", display: "grid", placeItems: "center", p: 2 }}>
      <Paper variant="outlined" sx={{ p: 4, maxWidth: 420, mx: "auto", mt: 8, width: "100%" }}>
        <Typography variant="h1" sx={{ mb: 2, textAlign: "center" }}>
          BidRL
        </Typography>
        <Typography sx={{ fontSize: 13, color: "text.secondary", textAlign: "center", mb: 3 }}>
          Operator console
        </Typography>

        <Box component="form" onSubmit={onSubmit}>
          <Stack spacing={2}>
            <TextField
              label="Username"
              id="username"
              size="small"
              fullWidth
              autoFocus
              autoComplete="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
            <TextField
              label="Password"
              id="password"
              type="password"
              size="small"
              fullWidth
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />

            {error && <Alert severity="error">{error}</Alert>}

            <Button type="submit" variant="contained" fullWidth disabled={busy}>
              {busy ? "Signing in…" : "Sign in"}
            </Button>
          </Stack>
        </Box>

        <Typography sx={{ fontSize: 11, color: "text.secondary", textAlign: "center", mt: 3 }}>
          Sessions are stored in an HttpOnly cookie. Don't share your credentials.
        </Typography>
      </Paper>
    </Box>
  );
}
